import { render, staticRenderFns } from "./collectparam.vue?vue&type=template&id=1c844c85"
import script from "./collectparam.vue?vue&type=script&lang=js"
export * from "./collectparam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports